import { useRef } from "react"
import {
  AlertDialog,
  AlertDialogLabel,
  AlertDialogDescription,
} from "@reach/alert-dialog"
import { Button } from "@planningcenter/doxy-web"

export default function DeleteConfirmationDialog({
  label,
  description,
  deleteButtonText,
  onCancel,
  onDelete,
}: {
  label: string
  description: string
  deleteButtonText: string
  onCancel: () => void
  onDelete: () => void
}) {
  const cancelRef = useRef(null)

  return (
    <AlertDialog leastDestructiveRef={cancelRef}>
      <AlertDialogLabel>{label}</AlertDialogLabel>
      <AlertDialogDescription>
        <p>{description}</p>
        <div className="d-f jc-fe mt-3 g-1">
          <button // doxy-web Button encounters type error with ref prop
            onClick={onCancel}
            ref={cancelRef}
            className="btn naked-btn"
          >
            Cancel
          </button>
          <Button text={deleteButtonText} theme="destroy" onClick={onDelete} />
        </div>
      </AlertDialogDescription>
    </AlertDialog>
  )
}
